import { classify } from 'sidecar-utilities'

// Background and text color changes depending on the sentiment.
const colors = sentiment => {
  switch (sentiment) {
    case 'engage':
      return 'color-engage-default color-textOnEngage-bold-default'
    case 'risk':
      return 'color-bgRisk color-textOnRisk'
    case 'accent':
      return 'color-accent-default color-textOnAccent-bold-default'
    case 'notify':
      return 'color-notify-default color-textOnNotify-bold-default'
    case 'brand':
      return 'color-brand-default color-textOnBrand-default'
    case 'default':
    default:
      return 'color-inverse-default color-textOnInverse-default'
  }
}

export const counterStyles = ({ sentiment }) => {
  return classify({
    // Grab the sentiment-specific colors from the switch case
    color: colors(sentiment),
    // Use small and bold text
    font: 'sh-body-xs sh-strong',
    // Centers the content.
    display: 'inline-flex justify-center items-center',
    // Make the height and width of the counter be 20px.
    // If the content is wider then 20px (should be rare), the width can grow.
    size: 'h-5 min-w-5',
    // Padding top pushes the content down slightly so its more vertically centered.
    // Right/left padding gives the content more space when it gets wider than 20px.
    padding: 'pt-0.5 px-1.5',
    // Make it a circle
    style: 'rounded-full',
  })
}
